import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="m3.914 3 .07.82 1.313 14.836.047.516.492.14 5.953 1.665.188.046.21-.046 5.954-1.641.492-.14.047-.516 1.336-14.86.07-.797h-.82L4.734 3h-.82Zm1.64 1.5 12.891.023-1.218 13.5L12 19.477l-5.25-1.454L5.555 4.5ZM7.36 6.75l.493 5.602h6.421l-.21 2.414-2.063.562h-.023l-2.063-.562-.117-1.547H7.922l.258 2.976 3.797 1.055H12l3.797-1.055.515-5.695H9.54l-.164-1.898h7.102l.164-1.852H7.359Z" />
  </svg>
);

export default icon;
